if (document.querySelector('.primaryPortfolio')) {
    $('.primaryPortfolio__imageSlider').slick({
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '.primaryPortfolio__imageSlider__prev',
        nextArrow: '.primaryPortfolio__imageSlider__next',
        asNavFor: '.primaryPortfolio__descriptionSlider',
        autoplay: 1,
        autoplaySpeed: 10000,
        pauseOnHover: 1
    })
    $('.primaryPortfolio__descriptionSlider').slick({
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.primaryPortfolio__imageSlider'
    })
    const main = document.querySelector('main')
    const slider = document.querySelector('.primaryPortfolio__imageSlider__container')
    const desc  = document.querySelector('.primaryPortfolio__container')
    const container = document.querySelector('.primaryPortfolio')
    const height = window.innerHeight
    window.addEventListener('scroll', () => {
        const header = document.querySelector('.header')
        const body = document.querySelector('body')
        const placeholder = document.querySelector('.header__placeholder')
        if (window.scrollY > 0  > 0) {
            header.classList.remove('transparent');
            body.setAttribute('data-nav', '')
            // placeholder.style.minHeight = '50px'
            container.style.maxHeight = height - 76 + 'px'
            // container.style.minHeight = height - 76 + 'px'
            desc.style.bottom = '50px'
            // slider.style.top = '-50px'
            console.log('aa')

        } else {
            header.classList.add('transparent');
            container.style.maxHeight = height - 76 + 'px'
            // container.style.minHeight = height - 76 + 'px'
            // placeholder.style.minHeight = '0px'
            // slider.style.top = '0px'
            desc.style.bottom = '0px'
            body.setAttribute('data-nav', 'dark')
        }
    })
}
if (document.querySelector('.secondaryPortfolio')) {
    $('.secondaryPortfolio__slider--first').slick({
        arrows: true,
        dots: false,
        prevArrow: '.secondaryPortfolio__slider__prev--first',
        nextArrow: '.secondaryPortfolio__slider__next--first',
        slidesToShow: 1,
        slidesToScroll: 1,
    })
    $('.secondaryPortfolio__slider--second').slick({
        arrows: true,
        dots: false,
        prevArrow: '.secondaryPortfolio__slider__prev--second',
        nextArrow: '.secondaryPortfolio__slider__next--second',
        slidesToShow: 1,
        slidesToScroll: 1,
    })

}
if (document.querySelector('.singleProject')) {
    $('.singleProject__slider').slick({
        arrows: true,
        prevArrow: '.singleProject__slider__prev',
        nextArrow: '.singleProject__slider__next',
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: 0,
        autoplay: 1,
        autoplaySpeed: 4000
    })
}